module.exports = Em.Handlebars.compile("{{error}}");